import React from 'react'
// import React, { useRef, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import classNames from 'classnames'
// import { getCurrentDate } from '../../utils/date'
// import { DateRangePicker } from '../assessments'
import FilterSelection from '../common/FilterSelection'
import ClearFilters from '../common/ClearFilters'
import labels from '../../constants/labels'
const SubscriptionFilter = ({
  globalFilter,
  setGlobalFilter,
  handleClearFilter,
  isLoading,
  coachList,
}) => {
  const sowStatus = labels?.sowStatusLabel
  // const picker = useRef()
  // const [isResetForm, setIsResetForm] = useState(false)

  return (
    <section className='mb-2-5'>
      <Row className='user-payment-filters'>
        <Col className='col-4 mb-3'>
          <FilterSelection
            globalFilter={globalFilter}
            setGlobalFilter={setGlobalFilter}
            name='sowStatus'
            placeholder='Select SOW Status'
            inputClasses={classNames('user-input', {
              'pointer-cursor': !isLoading,
              'cursor-disabled': isLoading,
            })}
            options={sowStatus.map((status) => ({
              key: status.value,
              value:
                status.label === 'Draft'
                  ? 'To be sent for payment to the client(Draft)'
                  : status.label === 'Payment Failed'
                  ? 'Payment Issues(Failed)'
                  : status.label,
            }))}
            size='md'
            disabled={isLoading}
            key={globalFilter?.sowStatus}
          />
        </Col>
        {/* Date range of payment */}
        {/* <Col className='col-4 mb-3'>
          <DateRangePicker
            initialSettings={{
              maxSpan: { months: 6 },
              autoUpdateInput: false,
              opens: 'center',
              startDate: getCurrentDate(),
              endDate: getCurrentDate(),
            }}
            onApply={(start, end) => {
              setGlobalFilter({
                ...globalFilter,
                preDate: start,
                postDate: end,
              })
            }}
            //setOnHide={true}
            className='w-100'
            ref={picker}
            isUseKeyProp={isResetForm}
            {...(isResetForm && {
              key: globalFilter?.preDate || globalFilter?.postDate,
            })}
            disabled={isLoading}
          />
        </Col> */}

        <Col className='col-4 mb-3'>
          <FilterSelection
            globalFilter={globalFilter}
            setGlobalFilter={setGlobalFilter}
            name='coachName'
            placeholder='Select Coach'
            inputClasses={classNames('user-input', {
              'pointer-cursor': !isLoading,
              'cursor-disabled': isLoading,
            })}
            options={coachList.map((coach) => ({
              key: coach.fullName,
              value: coach.fullName,
            }))}
            size='md'
            disabled={isLoading}
            key={globalFilter?.coachName}
          />
        </Col>
      </Row>
      {(globalFilter.sowStatus !== '' ||
        // globalFilter.preDate ||
        // globalFilter.postDate ||
        globalFilter.coachName !== '') && (
        <ClearFilters
          wrapperClasses='payment-clear-filter text-right'
          onClick={handleClearFilter}
          // onClick={() => {
          //   handleClearFilter()
          //   // for reset payment date range
          //   picker.current.setStartDate('')
          //   picker.current.setEndDate('')
          //   setIsResetForm(true)
          //   setTimeout(() => {
          //     setIsResetForm(false)
          //   }, 200)
          // }}
          disabled={isLoading}
        />
      )}
    </section>
  )
}

export default SubscriptionFilter
